<div class="sizing-tool-summary">
  <div class="summary-content">
    <div class="summary-item">
      <span class="label">Calculation setup</span>
      <span class="value">
        @switch (sizingTool().sizingMode) {
          @case ('kva') {
            <span>{{ loadModeLabel() || '-' }}</span>
            <span>|</span>
            <span>Power factor {{ sizingTool().powerFactor ?? '-' }}</span>
            <span>|</span>
            <span>UPS {{ sizingTool().upsEfficiency ?? '-' }}%</span>
            <span>|</span>
            <span>Range: {{ batteryRangesText() || '-' }}</span>
          }
          @default {
            <span>{{ loadModeLabel() || '-' }}</span>
            <span>|</span>
            <span>Range: {{ batteryRangesText() || '-' }}</span>
          }
        }
      </span>
    </div>
    <div class="summary-item">
      <span class="label">Block configuration</span>
      <span class="value">
        <span>
          @if (blocVoltageNumber() !== undefined) {
            {{ blocVoltageNumber() }}V
          } @else {
            -
          }
        </span>
        <span>|</span>
        <span>{{ sizingTool().nbBlocks ?? '-' }}</span>
        <span>|</span>
        <span>
          @if (twoVoltBlocks() !== undefined) {
            {{ twoVoltBlocks() }} cells (2V)
          } @else {
            -
          }
        </span>
      </span>
    </div>
    <div class="summary-item">
      <span class="label">Design conditions</span>
      <span class="value">
        <span>Temp {{ sizingTool().designTemperature }}</span>
        <span>|</span>
        <span
          >Factors: {{ sizingTool().designCorrectionFactor }} /
          {{ sizingTool().agingCorrectionFactor }}</span
        >
      </span>
    </div>
    <div class="summary-item">
      <span class="label">Load and backup</span>
      <span class="value">
        <span>{{ sizingTool().loadValue }} {{ loadUnit() }}</span>
        <span>|</span>
        <span>{{ sizingTool().backupMinutes }} min</span>
      </span>
    </div>
  </div>
  <div class="summary-action">
    <a
      class="action"
      nz-typography
      title="Change configuration method"
      [routerLink]="['../step-two-sizing-power-voltage']"
    >
      <span nz-icon nzType="edit" nzTheme="outline"></span>
      Edit
    </a>
  </div>
</div>
